import React, { useEffect, useState } from "react";
import CustomCard from "../../../../components/d-reusable/CustomCard";
import CustomDrawer from "../../../../components/d-reusable/CustomDrawer";
import { Col, Row, Table } from "antd";
import "./style.css";
import {
  dummyObservation,
  dummyProjectsData,
  dummyQuadraantDetails,
  dummySingleCaseResultsData,
  mapMatchStatus,
  mapedProjectQuadrantStatus,
} from "../../../../d-helper";
import {
  capitalizeStatus,
  dentalBasePath,
  errorRequestHandel,
  formateDateAndTime,
  getAgeValidationTag,
  getMyInfoFromProjectCollaborators,
  getProjectCode,
  renderQuadrantTitle,
  transformQuadrantData,
  transformServerDataToMarkedTeeth,
} from "../../../../../helper";
import { dentalIcons } from "../../../../utils-icons/dentalIcons";
import CaseResultDetailDrawerContent from "./child/CaseResultDetailDrawerContent";
import CustomFilter from "../../../../components/d-reusable/CustomFilter";
import CustomDefaultButton from "../../../../components/d-reusable/CustomDefaultButton";
import CustomPrimaryButton from "../../../../components/d-reusable/CustomPrimaryButton";
import CustomButtonWithIcon from "../../../../components/d-reusable/CustomButtonWithIcon";
import DentalObservation from "./child/dental-observation/DentalObservation";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getCaseSimulationDetailsByCaseId } from "../../../../../components/https/projects-apis";
import CustomSpinner from "../../../../components/d-reusable/CustomSpiner";
import { useDispatch, useSelector } from "react-redux";
import {
  _onRecordUpdate,
  _onSetDentalRecordDataForUpdate,
} from "../../../../../redux/actions/dentalRecordAction";
import NoInformation from "../../../../components/no-information/NoInformation";

const caseTabs = [
  {
    id: 1,
    title: "Record Comparison",
    value: "teeth_details",
  },
  {
    id: 2,
    title: "Quadrant Landmarks",
    value: "quadrant_details",
  },
  {
    id: 3,
    title: "Dental Observations",
    value: "dental_observations",
  },
];
const SingleCaseResultDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const myInfo = useSelector((state) => state.general?.myInfo || null);
  const isProjectOpenForCollaboration = useSelector(
    (state) => state.general?.isProjectOpenForCollaboration || false
  );

  const [open, setOpen] = useState(false);
  const [details, setDetails] = useState(null);
  const [toothDetail, setToothDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState("teeth_details");

  useEffect(() => {
    getSimulationDetails();
  }, []);

  const getSimulationDetails = async () => {
    try {
      setLoading(true);
      const response = await getCaseSimulationDetailsByCaseId({ id: id });
      if (response.status === 200) {
        const result = response.data.data;
        setDetails(result);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error: error });
    }
  };

  const renderCaseView = (type) => {
    switch (type) {
      case "teeth_details":
        return renderTeethDetails();
        break;
      case "quadrant_details":
        return renderQuadrantDetails();
        break;
      case "dental_observations":
        return renderDentalObservation();
        break;

      default:
        return renderTeethDetails();
        break;
    }
  };
  const renderTeethDetails = () => {
    const toothTabData = details?.details?.filter(
      (item) => item.tooth && Object.keys(item.tooth).length > 0
    );

    return (
      <Table
        dataSource={toothTabData}
        columns={[
          {
            title: "Tooth Position",
            key: "iso",
            render: (text, record) => ` ISO ${record?.tooth?.iso}`,
          },
          {
            title: "Tooth Name",
            key: "toothName",
            render: (text, record) => record?.tooth?.name,
          },
          {
            title: "AM State",
            key: "amDetail",
            render: (text, record) => {
              if (!record?.am_record?.conditions?.length)
                return <NoInformation />;

              const groupedConditions = record.am_record.conditions.reduce(
                (acc, condition) => {
                  const identifier = condition?.parentCondition?.identifier;
                  if (!acc[identifier]) {
                    acc[identifier] = [];
                  }
                  acc[identifier].push(condition?.condition?.title);
                  return acc;
                },
                {}
              );

              return Object.entries(groupedConditions).map(
                ([identifier, titles]) => (
                  <div key={identifier}>
                    <p>{identifier}</p>
                    {titles.map((title, index) => (
                      <div key={index}>
                        <small>{title}</small>
                      </div>
                    ))}
                  </div>
                )
              );
            },
          },

          {
            title: "PM State",
            key: "pmDetail",

            render: (text, record) => {
              if (!record?.pm_record?.conditions?.length)
                return <NoInformation />;

              const groupedConditions = record.pm_record.conditions.reduce(
                (acc, condition) => {
                  const identifier = condition?.parentCondition?.identifier;
                  if (!acc[identifier]) {
                    acc[identifier] = [];
                  }
                  acc[identifier].push(condition?.condition?.title);
                  return acc;
                },
                {}
              );

              return Object.entries(groupedConditions).map(
                ([identifier, titles]) => (
                  <div key={identifier}>
                    <p>{identifier}</p>
                    {titles.map((title, index) => (
                      <div key={index}>
                        <small>{title}</small>
                      </div>
                    ))}
                  </div>
                )
              );
            },
          },
          {
            title: <div className="custom_header_col">Match Status</div>,
            key: "match_status",
            render: (text, record) => {
              const { textColor, bgColor, statusText } = mapMatchStatus(
                record.match_status
              );
              return (
                <div className="matchStatus_card_container">
                  <div
                    className="matchStatus_card"
                    style={{ background: bgColor, color: textColor }}
                  >
                    {statusText}
                  </div>
                </div>
              );
            },
          },

          {
            title: <div className="custom_header_col">View Details</div>,
            dataIndex: "action",
            key: "action",
            render: (text, record) => {
              // Ensure correct destructuring: text, record
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    fontSize: 12,
                    color: "#20C3FF",
                  }}
                  onClick={() => {
                    setToothDetail(record);
                    setOpen(true); // Use record's id to delete
                  }}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={dentalIcons.viewIcon}
                      alt="Share"
                      style={{ cursor: "pointer", paddingRight: 4 }}
                    />
                  </div>
                </div>
              );
            },
          },
        ]}
        pagination={false}
      />
    );
  };

  const renderQuadrantDetails = () => {
    const quadrantTabDataUnOrdered = details?.details?.filter(
      (item) => item.quadrant && item.quadrant !== ""
    );

    const quadrantOrder = ["ur", "ul", "ll", "lr"];

    const quadrantTabData = quadrantTabDataUnOrdered.sort((a, b) => {
      return (
        quadrantOrder.indexOf(a.quadrant) - quadrantOrder.indexOf(b.quadrant)
      );
    });

    return (
      <Table
        dataSource={quadrantTabData}
        columns={[
          {
            title: "Quadrant",
            // dataIndex: "quadrant",
            key: "quadrant",
            render: (text, record) => renderQuadrantTitle(record?.quadrant),
          },

          {
            title: "AM State",
            key: "amDetail",
            render: (text, record) => {
              const conditions = record?.am_record?.conditions;
              if (!conditions || conditions.length === 0) {
                return <NoInformation />;
              }

              return conditions.map((condition, index) => (
                <div key={index}>
                  <p>{condition?.parentCondition?.identifier}</p>
                  <small>{condition?.condition?.title}</small>
                </div>
              ));
            },
          },
          {
            title: "PM State",
            key: "pmDetail",
            render: (text, record) => {
              const conditions = record?.pm_record?.conditions;
              if (!conditions || conditions.length === 0) {
                return <NoInformation />;
              }

              return conditions.map((condition, index) => (
                <div key={index}>
                  <p>{condition?.parentCondition?.identifier}</p>
                  <small>{condition?.condition?.title}</small>
                </div>
              ));
            },
          },

          {
            title: <div className="custom_header_col">Match Status</div>,
            key: "match_status",
            render: (text, record) => {
              const { textColor, bgColor, statusText } = mapMatchStatus(
                record.match_status
              );
              return (
                <div className="matchStatus_card_container">
                  <div
                    className="matchStatus_card"
                    style={{ background: bgColor, color: textColor }}
                  >
                    {statusText}
                  </div>
                </div>
              );
            },
          },

          {
            title: "Record Details",
            dataIndex: "action",
            key: "action",
            render: (text, record) => {
              // Ensure correct destructuring: text, record
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    // gap: 15,
                    fontSize: 12,
                    color: "#20C3FF",
                  }}
                  onClick={() => {
                    setToothDetail(record);
                    setOpen(true); // Use record's id to delete
                  }}
                >
                  <div
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={dentalIcons.viewIcon}
                      alt="Share"
                      style={{ cursor: "pointer", paddingRight: 4 }}
                    />
                  </div>
                </div>
              );
            },
          },
        ]}
        pagination={false}
      />
    );
  };

  const renderDentalObservation = () => {
    const extractedData = details?.details.flatMap((item) => {
      const result = [];

      // AM Record Observation
      if (item.am_record?.observation) {
        result.push({
          id: item.am_record.id,
          type: item.am_record.type,
          observation: item.am_record.observation,
          details:
            item.am_record.type === "tooth"
              ? item.tooth
              : { quadrant: item.quadrant },
          recordType: "AM", // Adding a record type field for AM
        });
      }

      // PM Record Observation
      if (item.pm_record?.observation) {
        result.push({
          id: item.pm_record.id,
          type: item.pm_record.type,
          observation: item.pm_record.observation,
          details:
            item.pm_record.type === "tooth"
              ? item.tooth
              : { quadrant: item.quadrant },
          recordType: "PM", // Adding a record type field for PM
        });
      }

      return result;
    });

    return (
      <Table
        dataSource={extractedData}
        columns={[
          {
            title: "ISO",
            key: "detail",
            render: (text, record) => {
              if (record?.type === "tooth" && record?.details) {
                return `${record.details.iso}`;
              } else if (record?.type === "quadrant" && record?.details) {
                return `-`;
              }
              return "N/A"; // Fallback if no details are present
            },
          },

          {
            title: "Details",
            key: "detail",
            render: (text, record) => {
              if (record?.type === "tooth" && record?.details) {
                return `${record.details.name}`;
              } else if (record?.type === "quadrant" && record?.details) {
                return `${record.details.quadrant.toUpperCase()}`;
              }
              return "N/A"; // Fallback if no details are present
            },
          },

          {
            title: "AM State", // New column for AM observation
            dataIndex: "observation",
            key: "am_observation",
            render: (text, record) =>
              record.recordType === "AM" ? record.observation : "-", // Only display AM observations for AM records
          },

          {
            title: "PM State", // New column for PM observation
            dataIndex: "observation",
            key: "pm_observation",
            render: (text, record) =>
              record.recordType === "PM" ? record.observation : "-", // Only display PM observations for PM records
          },
        ]}
        pagination={false}
      />
    );
  };
  const onEditDentalRecord = (id, records, caseId, type) => {
    const transfromData = transformServerDataToMarkedTeeth(records);
    const transformedQuadrants = transformQuadrantData(records);
    dispatch(_onRecordUpdate(true));

    dispatch(
      _onSetDentalRecordDataForUpdate(transfromData, transformedQuadrants)
    );

    navigate(
      `${dentalBasePath}/projects/details/case/add-dental-record?project_id=${details?.project?.id}&case_id=${caseId}&case_type=${type}&from=simulation&simulation_id=${id}`
    );
  };

  const handleClickOnAmRecordToUpdate = () => {
    const filterData = details?.details
      .map((item) => item.am_record)
      .filter((record) => record && Object.keys(record).length > 0);

    onEditDentalRecord(id, filterData, details?.am_case_id, "am");
  };
  const handleClickOnPMRecordToUpdate = () => {
    const filterData = details?.details
      .map((item) => item.pm_record)
      .filter((record) => record && Object.keys(record).length > 0);

    onEditDentalRecord(id, filterData, details?.pm_case_id, "pm");
  };

  return (
    <div className="d-single_case_results_container">
      <CustomSpinner loading={loading} />
      <CustomCard>
        <div className="single_case_results_body">
          <h6>
            Comparison between AM Case
            <span style={{ color: "#20c3ff", margin: "0 5px" }}>
              {details?.am_case?.case_number}
            </span>
            and PM Case
            <span style={{ color: "#FB5858", margin: "0 5px" }}>
              {details?.pm_case?.case_number}
            </span>
          </h6>
          <br />
          <Row gutter={[20, 20]}>
            <Col md={3}>
              <div className="single_case_result_information">
                <p className="_case_key">Project Code</p>
                <p className="_case_value">{getProjectCode(details?.id)}</p>
              </div>
            </Col>
            <Col md={3}>
              <div className="single_case_result_information">
                <p className="_case_key">Date Created</p>
                <p className="_case_value">
                  {formateDateAndTime(details?.project?.created_at)}
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="single_case_result_information">
                <p className="_case_key">PM Case</p>
                <p className="_case_value">
                  {details?.pm_case?.temporary_identifier}
                </p>
              </div>
            </Col>
            <Col md={3}>
              <div className="single_case_result_information">
                <p className="_case_key">Best Match</p>
                <p className="_case_value">{details?.am_case?.full_name}</p>
              </div>
            </Col>
            <Col md={12}>
              <Row gutter={[10, 10]}>
                <Col md={5}>
                  <div
                    className="case_result_score_card"
                    style={{
                      borderLeftColor: "#20C3FF",
                      background: "#20C3FF12",
                    }}
                  >
                    <p className="_case_score_key" style={{ color: "#20C3FF" }}>
                      Score
                    </p>
                    <p className="_case_score_key" style={{ color: "#20C3FF" }}>
                      {details?.score}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="case_result_score_card"
                    style={{
                      borderLeftColor: "#15BC3A",
                      background: "#F4FFF5",
                    }}
                  >
                    <p className="_case_score_key" style={{ color: "#15BC3A" }}>
                      Matches
                    </p>
                    <p className="_case_score_key" style={{ color: "#15BC3A" }}>
                      {details?.match_count}
                    </p>
                  </div>
                </Col>
                <Col md={7}>
                  <div
                    className="case_result_score_card"
                    style={{
                      borderLeftColor: "#EF7D02",
                      background: "#FFFCE5",
                    }}
                  >
                    <p className="_case_score_key" style={{ color: "#EF7D02" }}>
                      Possible Matches
                    </p>
                    <p className="_case_score_key" style={{ color: "#EF7D02" }}>
                      {details?.possible_match_count}
                    </p>
                  </div>
                </Col>
                <Col md={6}>
                  <div
                    className="case_result_score_card"
                    style={{
                      borderLeftColor: "#DC1919",
                      background: "#FFF2F5",
                    }}
                  >
                    <p className="_case_score_key" style={{ color: "#DC1919" }}>
                      Mismatches
                    </p>
                    <p className="_case_score_key" style={{ color: "#DC1919" }}>
                      {details?.mismatch_count}
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
          <br />
          <br />
          {getAgeValidationTag(details?.am_case, details?.pm_case)}
          <br />
          <br />
          {selectedTab == "teeth_details" && (
            <Row
              gutter={[10, 10]}
              justify={"end"}
              style={{
                marginTop: 20,
                position: "absolute",
                right: 16,
                marginTop: -15,
              }}
            >
              <Col>
                {(myInfo?.canManageAmCases ||
                  isProjectOpenForCollaboration) && (
                  <CustomPrimaryButton
                    title="Update AM Record"
                    onClick={handleClickOnAmRecordToUpdate}
                  />
                )}
              </Col>
              <Col>
                {(myInfo?.canManagePmCases ||
                  isProjectOpenForCollaboration) && (
                  <CustomPrimaryButton
                    title="Update PM Record"
                    onClick={handleClickOnPMRecordToUpdate}
                    isPm={true}
                  />
                )}
              </Col>
            </Row>
          )}
          <CustomFilter
            filtersData={caseTabs}
            customClass={"custom-width"}
            selectedTab={selectedTab}
            onSelect={(value) => setSelectedTab(value)}
          />
          <br />
          {renderCaseView(selectedTab)}
        </div>
      </CustomCard>

      <CustomDrawer
        open={open}
        onClose={() => setOpen(false)}
        title="Details"
        width={500}
      >
        <CaseResultDetailDrawerContent toothDetail={toothDetail} />
      </CustomDrawer>
    </div>
  );
};

export default SingleCaseResultDetail;
